import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import FooterRegisterPage from "../Common/FooterRegisterPage";
import Header1 from "../Common/Header1";
import { useDispatch, useSelector } from "react-redux";
import ApiService from "../Service/ApiService";
import { toast } from "react-toastify";
import Loader from "../Helper/Loader";
import { setAccessToken, setBusinessToken } from "../Redux/UserSlice";
import ResendOtp from "./ResendOtp";
const VerifyOtp = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();
    // const inputs = useRef([]);
    const registerData = useSelector(state => state?.userData?.registerData)
    const businessToken = useSelector(state => state?.userData?.business_token)

    const [otp, setOtp] = useState('')
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(false)

    // console.log('Email on verify otp', registerData?.email)

    const verifyOtpApi = async () => {
        try {
            setError(true)
            if (otp?.length > 3) {
                setLoading(true)
                let data = await ApiService.request('post', ApiService.config.VerifyOtpApi, {
                    email: registerData?.email,
                    business_token: businessToken,
                    otp: otp
                })
                if (data?.status) {
                    dispatch(setAccessToken(data?.data?.access_token))
                    dispatch(setBusinessToken(data?.data?.business_token))
                    navigate('/basic-detail', { state: { email: data?.data?.email } })
                    toast.success(data?.message)
                } else {
                    toast.error(data?.message)
                }
            }
        } catch (error) {

        } finally {
            setLoading(false)
        }
    }

    // const makeOtp = (num) => {
    //     if (otp?.length < 4) {
    //         setOtp((prev) => prev + num);
    //     }
    // }

    console.log('Password', otp)

    const handleKeypress = e => {
        if (e.keyCode === 13) {
            verifyOtpApi()
        }
    }


    return (
        <>
            {loading && <Loader />}
            <div className="loginScreen-ref border-bottom">
                {/* Header Start  */}
                <Header1 />
                {/* Header End  */}
                {/* LSK Kenya Membership Registration Process html Start */}
                <div className="registration-section">
                    <div className="conatiner">
                        <div className="row">
                            <div>
                                <div className="registrationWrapperBox  rounded-15px border-top maxWidth-600">
                                    <div className="registration_card_without_header rounded-15px">
                                        <div className="registration_inner-box-padding" onKeyDown={handleKeypress}>
                                            <div>
                                                <div className="font-34px font-bold text-primary heading active">
                                                    Enter verification code
                                                </div>
                                            </div>
                                            {/* <form action="register-step-3-basic-details.php"> */}
                                            <div className="mt-27px">
                                                <div className="font-18px   mb-3 line-height-150">
                                                    Enter the code we've sent via email to
                                                    {" "} {registerData?.email}{" "}
                                                    <a
                                                        className="text-decoration-underline link-primary"
                                                        tabIndex={0}
                                                        onClick={() => {
                                                            navigate('/register')
                                                        }}
                                                    >
                                                        Change Email
                                                    </a>
                                                </div>
                                                <div className="mb-2 mb-md-2 pb-xl-1">
                                                    {/* <div className="form-control d-flex justify-content-between OPTcode"> */}
                                                    <div className="form-control d-flex justify-content-between">
                                                        <input
                                                            placeholder=""
                                                            className="border-0 text-start font-24px"
                                                            tabIndex={0}
                                                            value={otp}
                                                            onChange={(e) => {
                                                                setOtp(e.target.value)
                                                            }}
                                                        />
                                                        {/* {[0, 1, 2, 3]?.map((item, index) => {
                                                            return <input
                                                                key={index}
                                                                placeholder="-"
                                                                className="border-0 text-center font-24px"
                                                                ref={(el) => (inputs.current[index] = el)}
                                                                // onChange={(e) => handleChange(e, index)}
                                                                onChange={(e) => {
                                                                    if (e.target.value && index < inputs.current.length - 1) {
                                                                        inputs.current[index + 1].focus();
                                                                    } else {
                                                                        if (index > 0 && index < 3) {
                                                                            inputs.current[index - 1]?.focus();
                                                                        }
                                                                    }
                                                                    makeOtp(e.target.value)
                                                                }}
                                                                // onKeyDown={(e) => handleKeyDown(e, index)}
                                                                // tabIndex={0}
                                                                maxLength={1}
                                                            />
                                                        })} */}
                                                        {/* <input
                                                            placeholder="-"
                                                            className="border-0 text-center font-24px"
                                                            tabIndex={0}
                                                        />
                                                        <input
                                                            placeholder="-"
                                                            className="border-0 text-center font-24px"
                                                            tabIndex={0}
                                                        />
                                                        <input
                                                            placeholder="-"
                                                            className="border-0 text-center font-24px"
                                                            tabIndex={0}
                                                        />
                                                        <input
                                                            placeholder="-"
                                                            className="border-0 text-center font-24px"
                                                            tabIndex={0}
                                                        />
                                                        <input
                                                            placeholder="-"
                                                            className="border-0 text-center font-24px"
                                                            tabIndex={0}
                                                        /> */}
                                                    </div>
                                                    {(otp == '' && error) ? <><p className='error'>Please enter otp.</p> <br /></>
                                                        : (otp?.length < 4 && error) ? <> <p className='error'>Please enter 4 digit otp.</p> <br /></> : ''}
                                                </div>
                                                {/* <div className="font-primary font-16px  mb-3 pb-xl-1">
                                                    Resend code in 00:30
                                                </div> */}
                                                <ResendOtp />
                                            </div>
                                            <div className="mb-3 pb-xl-1">
                                                <button
                                                    type="submit"
                                                    className="btn btn-primary w-100 coustom-btn font-20px font-semibold"
                                                    onClick={() => {
                                                        verifyOtpApi()
                                                        // navigate('/basic-detail')
                                                    }}
                                                >
                                                    Submit
                                                </button>
                                            </div>
                                            {/* </form> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* LSK Kenya Membership Registration Process html End */}
            </div>
            {/*Footer Start*/}
            <FooterRegisterPage />
            {/*Footer End*/}
        </>
    )
}
export default VerifyOtp;